import MarkdownContent from './markdownContent'

export default MarkdownContent
